/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BusinessApplicationInReviewListItem } from '../models/BusinessApplicationInReviewListItem';
import type { BusinessCompleteViewModel } from '../models/BusinessCompleteViewModel';
import type { CreateDraftBusinessApplicationPayload } from '../models/CreateDraftBusinessApplicationPayload';
import type { CreateDraftBusinessApplicationResponse } from '../models/CreateDraftBusinessApplicationResponse';
import type { DraftBusinessApplicationListItem } from '../models/DraftBusinessApplicationListItem';
import type { GetDraftBusinessApplicationPreviewResponse } from '../models/GetDraftBusinessApplicationPreviewResponse';
import type { GetDraftBusinessApplicationResponse } from '../models/GetDraftBusinessApplicationResponse';
import type { UpdateDraftBusinessApplicationPayload } from '../models/UpdateDraftBusinessApplicationPayload';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class BusinessOnboardingService {
    /**
     * @param requestBody
     * @returns CreateDraftBusinessApplicationResponse Success
     * @throws ApiError
     */
    public static postApiBusinessOnboardingCreateDraftBusinessApplication(
        requestBody?: CreateDraftBusinessApplicationPayload,
    ): CancelablePromise<CreateDraftBusinessApplicationResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/business-onboarding/CreateDraftBusinessApplication',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Invalid access token`,
            },
        });
    }
    /**
     * @param id
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static putApiBusinessOnboardingUpdateDraftBusinessApplication(
        id: string,
        requestBody?: UpdateDraftBusinessApplicationPayload,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/business-onboarding/UpdateDraftBusinessApplication/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Invalid access token`,
            },
        });
    }
    /**
     * @param id
     * @returns GetDraftBusinessApplicationResponse Success
     * @throws ApiError
     */
    public static getApiBusinessOnboardingGetDraftBusinessApplication(
        id: string,
    ): CancelablePromise<GetDraftBusinessApplicationResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/business-onboarding/GetDraftBusinessApplication/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Invalid access token`,
                404: `Not Found`,
            },
        });
    }
    /**
     * @param companyId
     * @param id
     * @returns GetDraftBusinessApplicationPreviewResponse Success
     * @throws ApiError
     */
    public static getApiBusinessOnboardingGetDraftBusinessApplicationPreview(
        companyId: string,
        id: string,
    ): CancelablePromise<GetDraftBusinessApplicationPreviewResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/business-onboarding/GetDraftBusinessApplicationPreview/{companyId}/{id}',
            path: {
                'companyId': companyId,
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
            },
        });
    }
    /**
     * @param companyId
     * @param businessId
     * @returns BusinessCompleteViewModel Success
     * @throws ApiError
     */
    public static getApiBusinessOnboardingGetPublishedBusinessPreview(
        companyId: string,
        businessId: string,
    ): CancelablePromise<BusinessCompleteViewModel> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/business-onboarding/GetPublishedBusinessPreview/{companyId}/{businessId}',
            path: {
                'companyId': companyId,
                'businessId': businessId,
            },
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
            },
        });
    }
    /**
     * @returns DraftBusinessApplicationListItem Success
     * @throws ApiError
     */
    public static getApiBusinessOnboardingListDraftBusinessApplications(): CancelablePromise<Array<DraftBusinessApplicationListItem>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/business-onboarding/ListDraftBusinessApplications',
            errors: {
                400: `Bad Request`,
                401: `Invalid access token`,
            },
        });
    }
    /**
     * @param id
     * @returns void
     * @throws ApiError
     */
    public static deleteApiBusinessOnboardingDeleteDraftBusinessApplication(
        id: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/business-onboarding/DeleteDraftBusinessApplication/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Invalid access token`,
                404: `Not Found`,
            },
        });
    }
    /**
     * @param id
     * @returns void
     * @throws ApiError
     */
    public static postApiBusinessOnboardingSubmitDraftBusinessApplicationForReview(
        id: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/business-onboarding/SubmitDraftBusinessApplicationForReview/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Invalid access token`,
                404: `Not Found`,
            },
        });
    }
    /**
     * @returns BusinessApplicationInReviewListItem Success
     * @throws ApiError
     */
    public static getApiBusinessOnboardingListBusinessApplicationsInReview(): CancelablePromise<Array<BusinessApplicationInReviewListItem>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/business-onboarding/ListBusinessApplicationsInReview',
            errors: {
                400: `Bad Request`,
                401: `Invalid access token`,
            },
        });
    }
}
